export default __webpack_public_path__ + "static/media/financialRag.3b817f96.png";